import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        loading: Boolean
    }
    static targets = ['pageTrigger', 'pageLink'];

    initialize() {
        this.loading = false;
        this.createObserver = this.createObserver.bind(this);
        this.lastFocusedElement = null;
    }

    connect() {
        this.createObserver();
    }

    createObserver() {
        if (this.hasPageTriggerTarget) {
            const observer = new window.IntersectionObserver(([entry]) => {
                if (entry.isIntersecting && !this.loading) {
                    this.loadMoreContent();
                }
            }, {
                root: null,
                threshold: 1,
            });
            observer.observe(this.pageTriggerTarget);
        }
    }

    loadMoreContent() {
        const checkResults = parseInt(document.getElementById('checkResults').innerText);
        const currentSize = parseInt(document.getElementById('resultsNumber').value);
        
        if (!this.loading && checkResults >= currentSize) {
            this.loading = true;
            const batchSize = 12;
            document.getElementById('resultsNumber').value = currentSize + batchSize;
            
            this.lastFocusedElement = document.activeElement;
            const lastFocusedIndex = this.getElementIndex(this.lastFocusedElement);
            
            document.addEventListener('turbo:before-stream-render', this.handleBeforeStreamRender.bind(this), { once: true });
            
            setTimeout(() => {
                const submitButton = document.getElementById("submit-button");
                submitButton.setAttribute('data-scrollTrigger', 'true');
                submitButton.click();
                submitButton.removeAttribute('data-scrollTrigger');
                
                setTimeout(() => {
                    this.loading = false;
                    
                    this.restoreFocus(lastFocusedIndex);
                }, 500);
            }, 100);
        }
    }
    
    getElementIndex(element) {
        if (!element || !element.parentNode) return -1;
        
        if (element.classList.contains('career-row')) {
            const careerRows = document.querySelectorAll('.career-row');
            return Array.from(careerRows).indexOf(element);
        }
        
        return -1;
    }
    
    handleBeforeStreamRender(event) {
        const targetId = event.target.getAttribute('target');
        if (targetId === 'career-search-turbo') {
            event.preventDefault();
            
            event.target.performAction();
        }
    }
    
    restoreFocus(lastFocusedIndex) {
        if (lastFocusedIndex >= 0) {
            const careerRows = document.querySelectorAll('.career-row');
            
            if (careerRows.length > 0) {
                const indexToFocus = Math.min(lastFocusedIndex, careerRows.length - 1);
                if (careerRows[indexToFocus]) {
                    careerRows[indexToFocus].focus();
                    return;
                }
            }
        }
        
        const container = document.querySelector('[data-careerSearchTool-target="container"]');
        if (container) {
            const firstCareerRow = container.querySelector('.career-row');
            if (firstCareerRow) {
                firstCareerRow.focus();
            }
        }
    }
}
